import * as createActions from "./storeComponents/createActions";

export default createActions;